"use client";

import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, XCircle, Info } from "lucide-react";
import { useToast } from "@/contexts/toast-context";

const variantConfig = {
  success: {
    icon: CheckCircle2,
    border: "border-accent/30",
    iconColor: "text-accent",
  },
  error: {
    icon: XCircle,
    border: "border-danger/30",
    iconColor: "text-danger",
  },
  info: {
    icon: Info,
    border: "border-border",
    iconColor: "text-muted",
  },
} as const;

export function ToastContainer() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {toasts.map((t) => {
          const cfg = variantConfig[t.variant];
          const Icon = cfg.icon;
          return (
            <motion.div
              key={t.id}
              role={t.variant === "error" ? "alert" : "status"}
              initial={{ opacity: 0, y: 16, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 16, scale: 0.95 }}
              transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
              onClick={() => dismiss(t.id)}
              className={`pointer-events-auto bg-surface rounded-lg px-3 py-2 text-[13px] text-foreground flex items-center gap-2 cursor-pointer border ${cfg.border}`}
              style={{ boxShadow: "0 4px 24px rgba(0,0,0,0.4)" }}
            >
              <Icon className={`w-3.5 h-3.5 flex-shrink-0 ${cfg.iconColor}`} />
              {t.message}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
